import INFTCollections from '../../models/INFTCollections'
import CryptoSealCard from '../../nftFormats/CryptoSeals/Card/CryptoSealCard'
import CryptoSealDetail from '../../nftFormats/CryptoSeals/Detail/CryptoSealDetail'
import CryptoSealActivtyDetail from '../../nftFormats/CryptoSeals/Activity/CryptoSealActivtyDetail'
import CryptoSealsLogo from '../../../../assets/nft-logo/cryptoSeals.png'

export const CryptosealData: INFTCollections[] = [
  {
    id: 'cryptoSeals',
    tokenAddress: '0x0540e4ee0c5cdba347c2f0e011acf8651bb70eb9',
    name: 'Cryptoseals',
    cardFormat: CryptoSealCard,
    detailFormat: CryptoSealDetail,
    activityFormat: CryptoSealActivtyDetail,
    category: 1,
    creatorAddress: '0xc5e5ec38de39c632f67ebf9795cd1d7d12331799',
    logo: CryptoSealsLogo,
    website: 'https://cryptoseals.art/',
    twitter: 'CryptoSeals',
    discord: 'https://discord.com/invite/YDxNmqyfdF'
  },
  {
    id: 'cryptoSealsPOANFT',
    tokenAddress: '0x0dBD60d135154C86A29fa3554b0BFf462a38708B',
    name: 'CryptoSeals Istanbul POAP NFT',
    cardFormat: CryptoSealCard,
    detailFormat: CryptoSealDetail,
    activityFormat: CryptoSealActivtyDetail,
    category: 1,
    creatorAddress: '0xc5e5ec38de39c632f67ebf9795cd1d7d12331799',
    logo: CryptoSealsLogo,
    website: 'https://cryptoseals.art/',
    twitter: 'CryptoSeals',
    discord: 'https://discord.com/invite/YDxNmqyfdF'
  }
]

export const CryptosealCategoryData = {
  [CryptosealData[0].tokenAddress.toLowerCase()]: CryptosealData[0].category,
  [CryptosealData[1].tokenAddress.toLowerCase()]: CryptosealData[1].category
}
